import { render, staticRenderFns } from "./RequestResponsesMatrix.vue?vue&type=template&id=6a325a56&scoped=true"
import script from "./RequestResponsesMatrix.vue?vue&type=script&lang=js"
export * from "./RequestResponsesMatrix.vue?vue&type=script&lang=js"
import style0 from "./RequestResponsesMatrix.vue?vue&type=style&index=0&id=6a325a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a325a56",
  null
  
)

export default component.exports